// import { useEffect } from 'react';

// Context
// import { useGlobalState } from '@wearetla/tla-essentials-tools/utilities/global-state';

// Services
// import systemServices from '/services/system';

// TODO: Sabit adı backend tarafından oluşturulunca güncellenecek.
// const lotteryConstantGroup = 'LOTTERY';
// const lotteryConstantKey = 'IPHONE_LOTTERY_ACTIVE';

// const truthyConstantValues = ['1', 'true', 'TRUE', 'active', 'ACTIVE'];

// const getLotteryEnabled = () => {
// 	return systemServices
// 		.getSysConstant(lotteryConstantGroup, lotteryConstantKey)
// 		.then((constants) => truthyConstantValues.includes(constants?.[0]?.value));
// };

export const GlobalStateController = () => {
	// const { lotteryEnabled, setData } = useGlobalState();

	// CSR fallback.
	// useEffect(() => {
	// 	if (lotteryEnabled === undefined || lotteryEnabled === null) {
	// 		getLotteryEnabled()
	// 			.then((lotteryEnabled) => {
	// 				setData('lotteryEnabled', lotteryEnabled);
	// 			})
	// 			.catch(() => {
	// 				setData('lotteryEnabled', false);
	// 			});
	// 	}
	// }, [lotteryEnabled]);

	return null;
};

GlobalStateController.getServerProps = () => {
	return new Promise((resolve) => {
		resolve();
		// Promise.all([
		// 	getLotteryEnabled().catch((e) => {
		// 		console.error('Initial props error - getLotteryEnabled', e);
		// 		return null;
		// 	}),
		// ]).then(([lotteryEnabled]) => {
		// 	resolve({
		// 		lotteryEnabled,
		// 	});
		// });
	});
};
